export default {
  "nav.home": "Home",
  "nav.activities": "Activities",
  "nav.courts": "Courts",
  "nav.pricing": "Pricing",
  "nav.tournaments": "Tournaments",
  "nav.advertisers": "Advertisers",
  "nav.investors": "Investors",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.bookCourt": "Book a Court",
  "nav.downloadApp": "Download App",
  "footer.slogan": "Tennis Excellence at the Heart of Africa",
  "footer.quickLinks": "Quick Links",
  "footer.followUs": "Follow Us",
  "footer.mobileApp": "Mobile App",
  "footer.contact": "Contact",
  "footer.copyright": "© 2026 Tennis Club de Douala. All rights reserved.",
  "footer.legal": "Legal Notice",
  "footer.privacy": "Privacy Policy",
  "lang.switch": "FR",
  "lang.label": "Language",
  "hero.title": "Tennis Excellence",
  "hero.titleHighlight": "at the Heart of Africa",
  "hero.subtitle": "Tennis Club de Bonanjo — Douala, Cameroon",
  "hero.ctaJoin": "Join the Club",
  "hero.ctaBook": "Book a Court",
  "hero.badge1": "ITF Tournaments",
  "hero.badge2": "6 Courts",
  "hero.badge3": "Internationally Certified",
  "hero.scrollDown": "Discover",
  "numbers.courts": "Courts Available",
  "numbers.hours": "Open 7/7 — 8am to 10pm",
  "numbers.members": "Active Members",
  "numbers.itf": "ITF J30 Tournaments Hosted",
  "numbers.coaches": "Certified Coaches",
  "numbers.camp": "Youth at Kid Summer Camp",
  "vision.title": "Our Vision",
  "vision.subtitle": "President's Message",
  "vision.quote": "Our ambition is to make Tennis Club de Douala the premier tennis destination in Douala and Cameroon. We practice tennis and promote it through the discovery and development of future champions.",
  "vision.point1": "Complete club revitalization — infrastructure and positioning",
  "vision.point2": "Internationally certified coach training programs",
  "vision.point3": "Construction and renovation of ITF-standard courts",
  "vision.point4": "Padel expansion — the world's fastest-growing sport",
  "vision.point5": "International reach — tournaments and partnerships",
  "vision.cta": "Learn More",
  "courts.title": "Our Courts",
  "courts.subtitle": "World-class facilities in the heart of Douala",
  "courts.central": "Center Court",
  "courts.centralDesc": "Main court — Competitions and official matches",
  "courts.standard": "Standard Court",
  "courts.training": "Training Court",
  "courts.padel": "Coming Soon — Padel Courts",
  "courts.padelDesc": "Planned expansion — The world's fastest-growing sport arrives at TCD",
  "courts.cta": "Book a Court",
  "courts.total": "Available facilities",
  "pricing.title": "Pricing & Membership",
  "pricing.subtitle": "Plans tailored to your practice",
  "pricing.monthly": "Monthly",
  "pricing.yearly": "Yearly",
  "pricing.kids": "Kid Summer Camp",
  "pricing.monthlyPrice": "24,000 XAF",
  "pricing.yearlyPrice": "288,000 XAF",
  "pricing.kidsPrice": "35,000 XAF",
  "pricing.perMonth": "/month",
  "pricing.perYear": "/year",
  "pricing.bestOffer": "Best value",
  "pricing.monthlyFeatures": "Unlimited court access · Group lessons · Locker rooms · Floodlights · Priority booking",
  "pricing.yearlyFeatures": "All monthly + · 2 months free · Personalized coaching · Free guests (2/month) · VIP event access",
  "pricing.kidsFeatures": "Daily tennis · AI workshops · Yoga & Pilates · Team sports · Personal development",
  "pricing.note": "Download our mobile app to book your courts",
  "pricing.cta": "Sign Up",
  "app.title": "Book your court in seconds",
  "app.subtitle": "Our mobile app lets you book courts, track events, and stay connected to the club wherever you are.",
  "app.feature1": "Instant booking",
  "app.feature2": "Event calendar",
  "app.feature3": "Club news",
  "app.feature4": "Real-time notifications",
  "app.googlePlay": "Get it on Google Play",
  "app.appStore": "Download on the App Store",
  "news.title": "News & Events",
  "news.subtitle": "The latest from Tennis Club de Douala",
  "news.viewAll": "View all news",
  "gallery.title": "Gallery",
  "gallery.subtitle": "Tennis Club de Douala in pictures",
  "gallery.all": "All",
  "gallery.courts": "Courts",
  "gallery.tournaments": "Tournaments",
  "gallery.coaching": "Coaching",
  "gallery.kids": "Kids",
  "gallery.events": "Events",
  "storeModal.title": "Choose your store",
  "storeModal.subtitle": "Download the app to book your court in seconds",
  "storeModal.getItOn": "Get it on",
  "storeModal.googlePlay": "Google Play",
  "storeModal.downloadOn": "Download on",
  "storeModal.appStore": "App Store"
}